import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";

export default function Login() {
  const { t } = useLang();
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const googleLogin = () => {
    const redirect = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      const path =
        u.role === "admin" || u.role === "moderator"
          ? "/admin/dashboard"
          : u.role === "agency"
          ? "/dashboard/agency"
          : u.role === "independent"
          ? "/dashboard/independent"
          : "/dashboard/client";
      nav(path);
    } catch (e) { console.warn("[Login.jsx] non-blocking error:", e); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] max-w-md mx-auto px-4 py-16" data-testid="login-page">
      <p className="text-overline">Relaxora</p>
      <h1 className="font-heading text-4xl text-white mt-2 mb-8 font-light">{t.auth.login}</h1>
      <form onSubmit={submit} className="space-y-4">
        <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder={t.auth.email} required className="w-full bg-[#121212] border border-white/10 rounded-md px-4 py-3 text-white focus:border-gold/50 focus:outline-none" data-testid="login-email" />
        <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" placeholder={t.auth.passwordLabel} required className="w-full bg-[#121212] border border-white/10 rounded-md px-4 py-3 text-white focus:border-gold/50 focus:outline-none" data-testid="login-password" />
        <button disabled={busy} className="btn-gold rounded-md px-6 py-3 text-sm w-full disabled:opacity-50" data-testid="login-submit">{busy ? "…" : t.auth.login}</button>
      </form>
      <div className="my-6 flex items-center gap-3 text-xs text-[#737373]">
        <div className="flex-1 h-px bg-white/5" /> OR <div className="flex-1 h-px bg-white/5" />
      </div>
      <button onClick={googleLogin} className="btn-ghost-dark rounded-md px-4 py-3 w-full text-sm flex items-center justify-center gap-2" data-testid="google-login">
        <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5h-1.9V20H24v8h11.3c-1.7 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.4-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16.1 19 13 24 13c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 10-2 13.6-5.3l-6.3-5.2C29.2 35 26.7 36 24 36c-5.3 0-9.6-3.4-11.3-8l-6.5 5C9.6 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.2-4.3 5.5l6.3 5.2C41.4 36 44 30.5 44 24c0-1.2-.1-2.4-.4-3.5z"/></svg>
        {t.auth.google}
      </button>
      <p className="text-sm text-[#a3a3a3] mt-6 text-center">
        {t.auth.no_account} <Link to="/register" className="text-gold">{t.auth.register}</Link>
      </p>
    </div>
  );
}
